"use client";
import { loginUser } from "@/app/(my-app)/auth/actions";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState, useTransition } from "react";
import { toast } from "react-toastify";
import LoadingSpinner from "./ui/loading-spinner";
export default function LoginForm({ redirectTo }: { redirectTo?: string }) {
  const initialState = {
    message: "",
  };

  const [formState, setFormState] = useState(initialState);
  const [isPending, startTransition] = useTransition();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);

    startTransition(async () => {
      const result = await loginUser({ message: formState.message }, formData);
      if (result.message) {
        toast.error(result.message);
      }
      setFormState(result);
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid gap-2">
        <Input
          id="email"
          label="Correo electrónico"
          type="email"
          placeholder="nutriolift@ejemplo.com"
          name="email"
          required
        />
      </div>
      <div className="grid gap-2 mt-2">
        <Input
          id="password"
          placeholder="******"
          label="Contraseña"
          type="password"
          name="password"
          required
        />
      </div>
      <input type="hidden" name="redirectTo" value={redirectTo} />
      <Button className="w-full mt-4" type="submit" disabled={isPending}>
        {isPending ? <LoadingSpinner /> : "Iniciar sesión"}
      </Button>
    </form>
  );
}
